export function formatSchwachstellenStatusDisplay(statusName?: string): string {
  if (!statusName) return 'Entwurf';
  if (statusName === 'Geprueft') return 'Geprüft';
  return statusName;
}
